import usePreviewFeatures from './usePreviewFeatures';
import { isSchedulingUiEnabled } from '../Utils/scheduling_utils';

export default function useSchedulingEnabled() {
  return isSchedulingUiEnabled(usePreviewFeatures());
}
